export default __webpack_public_path__ + "static/media/icon-trophy-white.1dc8bf68.svg";